import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchOrderDetails } from "ducks/actions";
import {
  makeSelectIsFetchingData,
  makeSelectCanCancelNumberChange,
  makeSelectCanRequestNumberChange,
  makeSelectGuestOrderOrderRef,
  makeSelectEligibility,
  makeSelectOrderDetails
} from "ducks/selectors";
import Spinner, { styles } from "components/Spinner";
import { ORDER_ACTION_TYPES, paths } from "utils/constants";
import NotEligible from "components/NotEligible";
import RequestNumberChange from "./RequestNumberChange";
import { createStructuredSelector } from "reselect";
import isEmpty from "lodash/isEmpty";
import { gotoUrl } from "utils/helpers";
import get from "lodash/get";

export const ChangeNumberAction = props => {
  const {
    isFetchingOrderDetails,
    canCancelNumberChange,
    canRequestNumberChange,
    eligibility,
    orderDetails
  } = props;

  useEffect(() => {
    if (canCancelNumberChange) {
      gotoUrl(paths.CHANGE_NUMBER_SUBMITTED);
    }
  }, [canCancelNumberChange]);

  useEffect(() => {
    if (
      !isEmpty(eligibility) &&
      !get(eligibility, "value") &&
      !canCancelNumberChange
    ) {
      gotoUrl(paths.CHANGE_NUMBER_INELIGIBLE);
    }
  }, [canCancelNumberChange, eligibility]);

  if (isFetchingOrderDetails || isEmpty(orderDetails))
    return <Spinner size={200} sx={styles.fullPage} />;

  if (canRequestNumberChange) {
    return <RequestNumberChange {...props} />;
  }

  return <NotEligible {...eligibility} />;
};

const mapStateToProps = createStructuredSelector({
  orderRef: makeSelectGuestOrderOrderRef(),
  orderDetails: makeSelectOrderDetails(),
  isFetchingOrderDetails: makeSelectIsFetchingData("orderDetails"),
  canCancelNumberChange: makeSelectCanCancelNumberChange(),
  canRequestNumberChange: makeSelectCanRequestNumberChange(),
  eligibility: makeSelectEligibility()
});

export function mapDispatchToProps(dispatch) {
  return {
    fetchOrderDetails: orderRef => {
      const params = {
        type: ORDER_ACTION_TYPES.CHANGE_NUMBER,
        order_ref: orderRef
      };

      dispatch(fetchOrderDetails(params));
    }
  };
}

ChangeNumberAction.defaultProps = {
  fetchOrderDetails: () => {}
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangeNumberAction);
